import { useOktaAuth } from '@okta/okta-react';

export default function LoginRedirect() {
  const { oktaAuth } = useOktaAuth();
  oktaAuth.signInWithRedirect();
  return '';
}
